import React from 'react';

import { gql } from '@apollo/client';
import type { EditableNameVariant } from 'src/components';
import { EditableNameInput } from 'src/components';
import { Apollo } from 'src/gql/generated';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  input: {
    minWidth: 400,
  },
}));

void gql`
  query GetReportName($reportId: UUID!) {
    report(reportId: $reportId) {
      __typename
      id
      name
    }
  }
`;

interface ReportNameProps {
  reportId: UUID | null;
  variant?: EditableNameVariant;
}

export function ReportNameInput({ reportId, variant }: ReportNameProps): JSX.Element | null {
  const { classes } = useStyles();
  const [updateReport] = Apollo.useUpdateReportMutation();
  const { data } = Apollo.useGetReportNameQuery({
    skip: !reportId,
    variables: { reportId: reportId ?? '' },
  });

  async function updateName(name: string): Promise<void> {
    if (!reportId) return;

    await updateReport({
      variables: { input: { reportId, reportProps: { name } } },
    });
  }

  if (!reportId) return null;

  return (
    <EditableNameInput
      inputBaseClassName={classes.input}
      name={data?.report?.name ?? ''}
      placeholder="Type report name..."
      updateName={updateName}
      variant={variant}
    />
  );
}
